module.exports = __webpack_public_path__ + "img/yyzz.0f804004.jpg";